// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Custom Turing checkbox styles based on Antd */

/* DEFAULT CHECKBOX */

.ant-checkbox-wrapper{
  margin-bottom: 4px;
}

.ant-checkbox{
  position: relative;
  z-index: 2 !important;
  width: 40px;
  height: 40px;
  border-radius: 100%;
}

.ant-checkbox::after {
  top: 11px;
  left: 11px;
}

.ant-checkbox input.ant-checkbox-input{
  z-index: 0 !important;
}

.ant-checkbox .ant-checkbox-inner{
  top: 11px;
  left: 11px;
  width: 18px;
  height: 18px;
  border: 2px solid #888888 !important;
  background-color: transparent;
}

/* on Focus */

.ant-checkbox-wrapper:focus-within .ant-checkbox{
  background-color: rgba(68, 68, 68, 0.12) !important;
}
.ant-checkbox:focus-within, .ant-checkbox.ant-checkbox-checked:focus-within{
  background-color: rgba(68, 68, 68, 0.12) !important;
}

/*
How Ant handles focus and active state
-
.ant-checkbox-input:focus + .ant-checkbox-inner {
  background-color: rgba(68, 68, 68, 0.12) !important;
-
We will have to make something around this styling logic to get our design
The problem here is that Ant puts focus on input and styles alement next to it,
but we want to style parent element.
}*/

.ant-checkbox-wrapper:focus .ant-checkbox-inner{
  border: 2px solid #888888;
}

/* on Click */

.ant-checkbox-wrapper:active .ant-checkbox, .ant-checkbox:active, .ant-checkbox-wrapper .ant-checkbox.ant-checkbox-checked:active{
  background-color: rgba(68, 68, 68, 0.18) !important;
}

.ant-checkbox-wrapper:active .ant-checkbox-inner{
  border: 2px solid #888888;
}

/* Checked */

.ant-checkbox.ant-checkbox-checked .ant-checkbox-inner{
  background-color: #444444;
  border: 2px solid #444444 !important;
}

.ant-checkbox.ant-checkbox-checked::after {
  border: none;
  animation: none;
}

/* Hover */

/*.ant-checkbox-wrapper:hover .ant-checkbox{
  background-color: rgba(68, 68, 68, 0.06);
}

.ant-checkbox-wrapper:hover .ant-checkbox-inner{
  border: 2px solid #888888;
}*/

.ant-checkbox:hover{
  background-color: rgba(68, 68, 68, 0.06);
}

.ant-checkbox:hover .ant-checkbox-inner{
  border: 2px solid #888888;
}

/*.ant-checkbox-wrapper:hover .ant-checkbox-checked .ant-checkbox-inner{
  border: 2px solid #444444 !important;
}*/

/* Disabled */

.ant-checkbox-wrapper-disabled .ant-checkbox-disabled{
  background-color: transparent !important;
}

.ant-checkbox-wrapper-disabled .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner{
  background-color: #AAAAAA !important;
  border: 2px solid #AAAAAA !important;
}

.ant-checkbox-wrapper-disabled .ant-checkbox-disabled .ant-checkbox-inner{
  border: 2px solid #AAAAAA !important;
}

.ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
  border-color: #fff !important;
}

/* INDETERMINATE */

.ant-checkbox.ant-checkbox-indeterminate{
  /*background-color: transparent !important;*/
}

/* Checked */

.ant-checkbox.ant-checkbox-indeterminate .ant-checkbox-inner{
  border: 2px solid #888888 !important;
}

.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-checked .ant-checkbox-inner{
  background-color: transparent !important;
}

.ant-checkbox.ant-checkbox-indeterminate .ant-checkbox-inner::after{
  background-color: transparent;
}

.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-checked .ant-checkbox-inner::after{
  background-color: #444444;
}

/* Disabled */

.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-disabled .ant-checkbox-inner{
  border: 2px solid #AAAAAA !important;
}

.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-disabled .ant-checkbox-inner::after{
  background-color: #AAAAAA !important;
}

.ant-checkbox-wrapper:active .ant-checkbox.ant-checkbox-disabled{
  background-color: transparent !important;
}

/* Hover */

.ant-checkbox-wrapper:hover .ant-checkbox-indeterminate.ant-checkbox-checked .ant-checkbox-inner{
  border: 2px solid #888888 !important;
}


/* WITH LABEL */

.ant-checkbox-wrapper + span, .ant-checkbox + span {
  font-size: 14px;
  color: #888888;
  /*padding-left: 0;*/
  display: inline-block;
  vertical-align: middle;
  padding-bottom: 3px;
}

/* Disabled */

.ant-checkbox-wrapper.ant-checkbox-wrapper-disabled + span, .ant-checkbox.ant-checkbox-disabled + span {
  color: #AAAAAA;
}

/* GROUP */

/* List checkboxes one under the other */

.cbx-list-group{

}

.cbx-list-group .ant-checkbox-group-item{
  display: block;
}

/* GROUP - indeterminate */

.group-indeterminate{

}

.group-indeterminate > .ant-checkbox-wrapper{
  margin-bottom: 10px;
}

.group-indeterminate .ant-checkbox-group{
  display: block;
  width: 100%;
  padding-left: 23px;
}

.group-indeterminate .ant-checkbox-group .ant-checkbox-group-item{
  display: block;
}




/* ANIMATION */

.ant-checkbox.ant-checkbox-checked::after {
  border: none;
  animation: none;
}
`, "",{"version":3,"sources":["webpack://./src/v3/components/Common/Checkbox/checkbox.css"],"names":[],"mappings":";AACA,gDAAgD;;AAEhD,qBAAqB;;AAErB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA,aAAa;;AAEb;EACE,mDAAmD;AACrD;AACA;EACE,mDAAmD;AACrD;;AAEA;;;;;;;;;EASE;;AAEF;EACE,yBAAyB;AAC3B;;AAEA,aAAa;;AAEb;EACE,mDAAmD;AACrD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,YAAY;;AAEZ;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,UAAU;;AAEV;;;;;;EAME;;AAEF;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE;;AAEF,aAAa;;AAEb;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,kBAAkB;;AAElB;EACE,4CAA4C;AAC9C;;AAEA,YAAY;;AAEZ;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,aAAa;;AAEb;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,UAAU;;AAEV;EACE,oCAAoC;AACtC;;;AAGA,eAAe;;AAEf;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,aAAa;;AAEb;EACE,cAAc;AAChB;;AAEA,UAAU;;AAEV,wCAAwC;;AAExC;;AAEA;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;;AAE1B;;AAEA;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;;;;AAKA,cAAc;;AAEd;EACE,YAAY;EACZ,eAAe;AACjB","sourcesContent":["\n/* Custom Turing checkbox styles based on Antd */\n\n/* DEFAULT CHECKBOX */\n\n.ant-checkbox-wrapper{\n  margin-bottom: 4px;\n}\n\n.ant-checkbox{\n  position: relative;\n  z-index: 2 !important;\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n}\n\n.ant-checkbox::after {\n  top: 11px;\n  left: 11px;\n}\n\n.ant-checkbox input.ant-checkbox-input{\n  z-index: 0 !important;\n}\n\n.ant-checkbox .ant-checkbox-inner{\n  top: 11px;\n  left: 11px;\n  width: 18px;\n  height: 18px;\n  border: 2px solid #888888 !important;\n  background-color: transparent;\n}\n\n/* on Focus */\n\n.ant-checkbox-wrapper:focus-within .ant-checkbox{\n  background-color: rgba(68, 68, 68, 0.12) !important;\n}\n.ant-checkbox:focus-within, .ant-checkbox.ant-checkbox-checked:focus-within{\n  background-color: rgba(68, 68, 68, 0.12) !important;\n}\n\n/*\nHow Ant handles focus and active state\n-\n.ant-checkbox-input:focus + .ant-checkbox-inner {\n  background-color: rgba(68, 68, 68, 0.12) !important;\n-\nWe will have to make something around this styling logic to get our design\nThe problem here is that Ant puts focus on input and styles alement next to it,\nbut we want to style parent element.\n}*/\n\n.ant-checkbox-wrapper:focus .ant-checkbox-inner{\n  border: 2px solid #888888;\n}\n\n/* on Click */\n\n.ant-checkbox-wrapper:active .ant-checkbox, .ant-checkbox:active, .ant-checkbox-wrapper .ant-checkbox.ant-checkbox-checked:active{\n  background-color: rgba(68, 68, 68, 0.18) !important;\n}\n\n.ant-checkbox-wrapper:active .ant-checkbox-inner{\n  border: 2px solid #888888;\n}\n\n/* Checked */\n\n.ant-checkbox.ant-checkbox-checked .ant-checkbox-inner{\n  background-color: #444444;\n  border: 2px solid #444444 !important;\n}\n\n.ant-checkbox.ant-checkbox-checked::after {\n  border: none;\n  animation: none;\n}\n\n/* Hover */\n\n/*.ant-checkbox-wrapper:hover .ant-checkbox{\n  background-color: rgba(68, 68, 68, 0.06);\n}\n\n.ant-checkbox-wrapper:hover .ant-checkbox-inner{\n  border: 2px solid #888888;\n}*/\n\n.ant-checkbox:hover{\n  background-color: rgba(68, 68, 68, 0.06);\n}\n\n.ant-checkbox:hover .ant-checkbox-inner{\n  border: 2px solid #888888;\n}\n\n/*.ant-checkbox-wrapper:hover .ant-checkbox-checked .ant-checkbox-inner{\n  border: 2px solid #444444 !important;\n}*/\n\n/* Disabled */\n\n.ant-checkbox-wrapper-disabled .ant-checkbox-disabled{\n  background-color: transparent !important;\n}\n\n.ant-checkbox-wrapper-disabled .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner{\n  background-color: #AAAAAA !important;\n  border: 2px solid #AAAAAA !important;\n}\n\n.ant-checkbox-wrapper-disabled .ant-checkbox-disabled .ant-checkbox-inner{\n  border: 2px solid #AAAAAA !important;\n}\n\n.ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {\n  border-color: #fff !important;\n}\n\n/* INDETERMINATE */\n\n.ant-checkbox.ant-checkbox-indeterminate{\n  /*background-color: transparent !important;*/\n}\n\n/* Checked */\n\n.ant-checkbox.ant-checkbox-indeterminate .ant-checkbox-inner{\n  border: 2px solid #888888 !important;\n}\n\n.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-checked .ant-checkbox-inner{\n  background-color: transparent !important;\n}\n\n.ant-checkbox.ant-checkbox-indeterminate .ant-checkbox-inner::after{\n  background-color: transparent;\n}\n\n.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-checked .ant-checkbox-inner::after{\n  background-color: #444444;\n}\n\n/* Disabled */\n\n.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-disabled .ant-checkbox-inner{\n  border: 2px solid #AAAAAA !important;\n}\n\n.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-disabled .ant-checkbox-inner::after{\n  background-color: #AAAAAA !important;\n}\n\n.ant-checkbox-wrapper:active .ant-checkbox.ant-checkbox-disabled{\n  background-color: transparent !important;\n}\n\n/* Hover */\n\n.ant-checkbox-wrapper:hover .ant-checkbox-indeterminate.ant-checkbox-checked .ant-checkbox-inner{\n  border: 2px solid #888888 !important;\n}\n\n\n/* WITH LABEL */\n\n.ant-checkbox-wrapper + span, .ant-checkbox + span {\n  font-size: 14px;\n  color: #888888;\n  /*padding-left: 0;*/\n  display: inline-block;\n  vertical-align: middle;\n  padding-bottom: 3px;\n}\n\n/* Disabled */\n\n.ant-checkbox-wrapper.ant-checkbox-wrapper-disabled + span, .ant-checkbox.ant-checkbox-disabled + span {\n  color: #AAAAAA;\n}\n\n/* GROUP */\n\n/* List checkboxes one under the other */\n\n.cbx-list-group{\n\n}\n\n.cbx-list-group .ant-checkbox-group-item{\n  display: block;\n}\n\n/* GROUP - indeterminate */\n\n.group-indeterminate{\n\n}\n\n.group-indeterminate > .ant-checkbox-wrapper{\n  margin-bottom: 10px;\n}\n\n.group-indeterminate .ant-checkbox-group{\n  display: block;\n  width: 100%;\n  padding-left: 23px;\n}\n\n.group-indeterminate .ant-checkbox-group .ant-checkbox-group-item{\n  display: block;\n}\n\n\n\n\n/* ANIMATION */\n\n.ant-checkbox.ant-checkbox-checked::after {\n  border: none;\n  animation: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
